import { Common, Comon } from '../model/common';


export class CommonService {
    public url: Array<string> = new Array<string>();
    public updatedType: string;
    public status: Common[] = [{ id: 1, name: "All" }, { id: 2, name: "Active" }, { id: 3, name: "Inactive" }];
    public consecratedStatus: Common[] = [{ id: 1, name: "Active" }, { id: 2, name: "Left Dioceses" }, { id: 3, name: "Deceased" }];
    public gender: Common[] = [{ id: 1, name: "Select" }, { id: 2, name: "Male" }, { id: 3, name: "Female" }];
    public primaryLanguage: Common[] = [{ id: 1, name: "All" }, { id: 2, name: "English" }, { id: 3, name: "Spanish" }, { id: 4, name: "Vietnamese" }];
    public knownLanguage: Common[] = [{ id: 1, name: 'ASL' }, { id: 2, name: 'Cantonese' }, { id: 3, name: 'Chinese' },
    { id: 4, name: 'English' }, { id: 5, name: 'French' }, { id: 6, name: 'Gaelic' }, { id: 7, name: 'German' },
    { id: 8, name: 'Hungarian' }, { id: 9, name: 'Italian' }, { id: 10, name: 'Joloono' }, { id: 11, name: 'Korean' },
    { id: 12, name: 'Latin' }, { id: 13, name: 'Polish' }, { id: 14, name: 'Portugese' }, { id: 15, name: 'Spanish' },
    { id: 16, name: 'Tagalog' }];
    public livingArrangement: Common[] = [{ id: 1, name: "Select" }, { id: 2, name: "Alone" }, { id: 3, name: "Community" }];
    public marital: Common[] = [{ id: 1, name: "Select" }, { id: 2, name: "Married" }, { id: 3, name: "Single" }, { id: 4, name: "Divorced" }, { id: 5, name: "Widowed" }];
    public state: Common[] = [{ id: 1, name: "Select" }, { id: 2, name: "AL" }, { id: 3, name: "AK" }, { id: 4, name: "AZ" }, { id: 5, name: "AR" },
    { id: 6, name: "AE" }, { id: 7, name: "AP" }, { id: 8, name: "CA" }, { id: 9, name: "CO" },
    { id: 10, name: "CT" }, { id: 11, name: "DE" }, { id: 12, name: "DC" }, { id: 13, name: "FL" },
    { id: 14, name: "GA" }, { id: 15, name: "HI" }, { id: 16, name: "ID" }, { id: 17, name: "IL" },
    { id: 18, name: "IN" }, { id: 19, name: "IA" }, { id: 20, name: "KS" }, { id: 21, name: "KY" },
    { id: 22, name: "LA" }, { id: 23, name: "ME" }, { id: 24, name: "MD" }, { id: 25, name: "MA" },
    { id: 26, name: "MI" }, { id: 27, name: "MN" }, { id: 28, name: "MS" }, { id: 29, name: "MO" },
    { id: 30, name: "MT" }, { id: 31, name: "NE" }, { id: 32, name: "NV" }, { id: 33, name: "NH" },
    { id: 34, name: "NJ" }, { id: 35, name: "NM" }, { id: 36, name: "NY" }, { id: 37, name: "NC" },
    { id: 38, name: "ND" }, { id: 39, name: "OH" }, { id: 40, name: "OK" }, { id: 41, name: "OR" },
    { id: 42, name: "PA" }, { id: 43, name: "RI" }, { id: 44, name: "SC" }, { id: 45, name: "SD" },
    { id: 46, name: "TN" }, { id: 47, name: "TX" }, { id: 48, name: "UT" }, { id: 49, name: "VT" },
    { id: 50, name: "VA" }, { id: 51, name: "WA" }, { id: 52, name: "WV" }, { id: 53, name: "WI" }, { id: 54, name: "WY" }];
    public addressType: Common[] = [{ id: 1, name: "Select" }, { id: 2, name: "Business" }, { id: 3, name: "Mailing" }, { id: 4, name: "Home" }, { id: 5, name: "Other" }];
    public location: Common[] = [
        { id: 1, name: "Select" },
        { id: 2, name: "Annunciation Catholic School" },
        { id: 3, name: "Blessed Sacrament Church" },
        { id: 4, name: "Blessed Sacrament School" },
        { id: 5, name: "Casa Santa Maria" },
        { id: 6, name: "Catholic Charities of Orange County" },
        { id: 7, name: "Catholic Deaf Community" },
        { id: 8, name: "Center For Spiritual Development" },
        { id: 9, name: "Christ Cathedral" },
        { id: 10, name: "Christ Cathedral Academy" },
        { id: 11, name: "Christ Cathedral Parish" },
        { id: 12, name: "Christ Our Savior Church" },
        { id: 13, name: "Corpus Christi Church" },
        { id: 14, name: "Heart of Jesus" },
        { id: 15, name: "Hoag Hospital" },
        { id: 16, name: "Miscellaneous Parish" },
        { id: 17, name: "Miscellaneous School" },
        { id: 18, name: "Mission Basilica San Juan Capistrano" },
        { id: 19, name: "Other" },
    ];
    public applicationType: Common[] = [{ id: 1, name: "Select" }, { id: 2, name: "Employee" }, { id: 3, name: "Volunteer" }];
    public type: Common[] = [{ id: 1, name: "Select" }, { id: 2, name: "Church" }, { id: 3, name: "School" }];
    public sacrament: Common[] = [{ id: 1, name: "Select" }, { id: 2, name: "Baptism" }, { id: 3, name: "Eucharist" },
    { id: 4, name: "Confirmation" },
    { id: 5, name: "Reconciliation" },
    { id: 6, name: "Anointing of the sick" },
    { id: 7, name: "Marriage" },
    { id: 8, name: "Holy orders" }
    ];
    public ministry: Common[] = [
        { id: 1, name: "Select" },
        { id: 2, name: "Candidacy" },
        { id: 3, name: "Reader/Lector" },
        { id: 4, name: "Acolyte" },
        { id: 5, name: "Deacon" },
        { id: 6, name: "Priest" }
    ];
    public seminary: Common[] = [
        { id: 1, name: "Select" },
        { id: 2, name: "Mt. Angel - Oregon" },
        { id: 3, name: "St. John's - Camarillo" },
        { id: 4, name: "St. Patrick's - Menlo Park" },
        { id: 5, name: "B. Miguel Pro- San Jose" },
        { id: 6, name: "Pontifical North American College - Rome" },
        { id: 7, name: "Language Systems International - Placentia" },
        { id: 8, name: "Community College - Local" },
        { id: 9, name: "Not Yet Assigned" },
        { id: 10, name: "Scared Heart School of Theology - Wisconsin" },
        { id: 11, name: "Seminario Hispano de Santa Maria de Guadalupe - Mexico" },
        { id: 12, name: "St. Augustine's Seminary of Toronto - Canada" }
    ];
    public prelate: Common[] = [{id:1,name:"Abp. Hunthausen"},
		{id:2,name:"Aemilius Berlie Beluanzaran, Bishop of Tiajuana"},
		{id:3,name:"Agnellum Cardinal Rossi"},
		{id:4,name:"Alberto Suarez Inda."},
		{id:5,name:"Andrew Nguyen Van Nam"},
		{id:6,name:"Archbishop Alter"},
		{id:7,name:"Archbishop Brhaneyesus Souraphiel"},
		{id:8,name:"Archbishop Denis E. Hurley, OMI"},
		{id:9,name:"Archbishop Dooley"},
		{id:10,name:"Archbishop Edward J. Hunkeler"},
		{id:11,name:"Archbishop James Francis McIntyre"},
		{id:12,name:"Archbishop John F. Donoghue"},
		{id:13,name:"Archbishop John Lawrence May"},
		{id:14,name:"Archbishop John McQuaid"},
		{id:15,name:"Archbishop John R. Quinn"},
		{id:16,name:"Archbishop Jose Mendez"},
		{id:17,name:"Archbishop Joseph T. McGucken"},
		{id:18,name:"Archbishop Joseph Walsh, D.D."},
		{id:20,name:"Archbishop Mar George Valiyamattom"},
		{id:21,name:"Archbishop Paul Binh Van Nguyen"},
		{id:22,name:"Archbishop Paul Nguyen van Binh"},
		{id:23,name:"Archbishop Paul Yu-Pin"},
		{id:24,name:"Archbishop Rolando Tria J. Tirona, O.C.D., D.D."},
		{id:25,name:"Archbishop Theodore McCarrick"},
		{id:26,name:"Archbishop Thomas J. Rode"},
		{id:27,name:"Archbishop Timothy Manning"},
		{id:28,name:"Archbishop William David O'Brien"},
		{id:29,name:"Bishop Albert Fletcher"},
		{id:30,name:"Bishop Bryagys - Lithuanian Bishop in Exile"},
		{id:31,name:"Bishop Canestri"},
		{id:32,name:"Bishop Carlos Sevilla, S.J."},
		{id:33,name:"Bishop David Arias, O.A.R, D.D."},
		{id:34,name:"Bishop Edward McGurkin, MM"},
		{id:35,name:"Bishop Herbert Hermes, O.S.B."},
		{id:36,name:"Bishop James McNulty"},
		{id:37,name:"Bishop John T. Steinbock, D.D."},
		{id:38,name:"Bishop Joseph McNicholas"},
		{id:39,name:"Bishop Julio X. Labayeng, BCP, D.D."},
		{id:40,name:"Bishop Justin Driscoll"},
		{id:41,name:"Bishop Keogh"},
		{id:42,name:"Bishop Ojea (White Fathers)"},
		{id:43,name:"Bishop Rolando Tria Tirona, OCD"},
		{id:44,name:"Bishop Sebastian Vayalil"},
		{id:45,name:"Bishop Terry Steib, SVS"},
		{id:46,name:"Bishop Zavala"},
		{id:47,name:"Blah Blah Blah"},
		{id:48,name:"BP Jebamalai Susaimanickam"},
		{id:49,name:"Cardinal"},
		{id:50,name:"Cardinal Anibal Munoz Duque"},
		{id:51,name:"Cardinal Archbishop J.B. Pham Minh Man"},
		{id:52,name:"Cardinal Ernesto Corripio Ahumada"},
		{id:53,name:"Cardinal Gaudencio B. Rosales, D.D."},
		{id:54,name:"Cardinal James Francis McIntyre"},
		{id:55,name:"Cardinal Jean Baptist Pham Minh Man"},
		{id:56,name:"Cardinal John Wright"},
		{id:57,name:"Cardinal Joseph Mindszenty"},
		{id:58,name:"Cardinal Nicolas de Jesus Lopez Rodriguez"},
		{id:59,name:"Cardinal Philipo Pocci"},
		{id:60,name:"Cardinal Stafford"},
		{id:61,name:"Cardinal Stephane Kim, Archbishop"},
		{id:62,name:"Cardinal Timothy Manning"},
		{id:63,name:"Cardinal Traglia"},
		{id:64,name:"Don. Apparecido Jose Dias"},
		{id:65,name:"Dr. Ahern Bishop of Cloyne"},
		{id:66,name:"Dr. James Staunton, Bishop of Ferns Diocese, Ireland"},
		{id:67,name:"Emmanuel Cardinal Nsubuga"},
		{id:68,name:"Emmanuel Cardinal Wamala"},
		{id:69,name:"Ersilio Tonini"},
		{id:70,name:"Examus. D.Fr. Arthurus Quintanilla, O.A.R."},
		{id:71,name:"H.E. Archbishop Timothy Broglio"},
		{id:72,name:"H.E. Joseph Pallikaparampil"},
		{id:73,name:"Hildebrando Cardinal Antoniutti"},
		{id:74,name:"His Eminence Cardinal Timothy Manning"},
		{id:75,name:"His Eminence James Francis Cardinal McIntyre"},
		{id:76,name:"His Eminence Timothy Cardinal Manning"},
		{id:77,name:"His Eminence, Cardinal Timothy Manning"},
		{id:78,name:"His Eminence, J. Francis Cardinal McIntyre"},
		{id:79,name:"His Eminence, Jaime Cardinal Sin"},
		{id:80,name:"His Emminance James Francis Cardinal McIntyre"},
		{id:81,name:"His Emminence Jorge Mario Cardinal Bergoglio"},
		{id:82,name:"His Holiness Pope Paul VI"},
		{id:83,name:"His Holiness Pope Paul, VI"},
		{id:84,name:"James Francis Cardinal McIntyre"},
		{id:85,name:"James Francis Cardinal MyIntyre, D.D."},
		{id:86,name:"James Francis, Cardinal McIntyre"},
		{id:87,name:"John Cardinal Cody"},
		{id:88,name:"Joseph Cardinal Bernardin"},
		{id:89,name:"Kurt Krenn, Vienna Austria"},
		{id:90,name:"Mons. Acevedo"},
		{id:91,name:"Mons. Josef Feranec"},
		{id:92,name:"Mons. Pedro Rubiano S."},
		{id:93,name:"Mons. Ricardo Tobon Restrepo"},
		{id:94,name:"Most Rev. Aemilius Carolus Berhi Beluanzaran"},
		{id:95,name:"Most Rev. Albert K. Obiefuna"},
		{id:96,name:"Most Rev. Alberto Suarez Inda"},
		{id:97,name:"Most Rev. Alexander Salazar, D.D."},
		{id:98,name:"Most Rev. Aloysius Cardinal Ambroziz"},
		{id:99,name:"Most Rev. Anthony Devotta"},
		{id:100,name:"Most Rev. Anthony Konings"},
		{id:101,name:"Most Rev. Antoni Dlvgosz"},
		{id:102,name:"Most Rev. Arturo Antonio Szymanski Ramirez"},
		{id:103,name:"Most Rev. Basil S. D'Souza"},
		{id:104,name:"Most Rev. Bernard Shiels, D.D."},
		{id:105,name:"Most Rev. Bernardino C. Cortez"},
		{id:106,name:"Most Rev. Bishop Joseph"},
		{id:107,name:"Most Rev. Boniface Choi"},
		{id:108,name:"Most Rev. Cardinal Joseph Bernadin"},
		{id:109,name:"Most Rev. Cardinal McIntyre"},
		{id:110,name:"Most Rev. Carlos Prada SanMiguel"},
		{id:111,name:"Most Rev. Carlos Sevilla"},
		{id:112,name:"Most Rev. Carolos Sevilla, D.d., SJ"},
		{id:113,name:"Most Rev. Carols Sevilla, SJ"},
		{id:114,name:"Most Rev. Charles Francis Buddy"},
		{id:115,name:"Most Rev. Cirilo Flores, D.D."},
		{id:116,name:"Most Rev. Cirilo Flores, J.D.,D.D."},
		{id:117,name:"Most Rev. Cletus O'Donnell"},
		{id:118,name:"Most Rev. Coleman Carroll, DD"},
		{id:119,name:"Most Rev. Cyprain Kizito Lwanga"},
		{id:120,name:"Most Rev. Cyril J. Vogel, D.D."},
		{id:121,name:"Most Rev. Dan Turley, O.S.A."},
		{id:122,name:"Most Rev. Daniel R. Jenky, CSC"},
		{id:123,name:"Most Rev. Daniel R., Jenky, C.S.C."},
		{id:124,name:"Most Rev. David Arias, O.A.R."},
		{id:125,name:"Most Rev. David Arias, OAR"},
		{id:126,name:"Most Rev. David Cronin"},
		{id:127,name:"Most Rev. Denis Moynihan"},
		{id:128,name:"Most Rev. Dominic Mai Luong"},
		{id:129,name:"Most Rev. Dominique Rey"},
		{id:130,name:"Most Rev. Donald W. Montrose, D.D."},
		{id:131,name:"Most Rev. Dr. A. Malayappan Chinnappa, S.D.B."},
		{id:132,name:"Most Rev. Dr. Morris"},
		{id:133,name:"Most Rev. Edmund Piszcz"},
		{id:134,name:"Most Rev. Edward F. Hoban"},
		{id:135,name:"Most Rev. Edward Hunkeler"},
		{id:136,name:"Most Rev. Edward J. Hunkeler"},
		{id:137,name:"Most Rev. Edward J. Hunkeler, D.D."},
		{id:138,name:"Most Rev. Edwin Groderich"},
		{id:139,name:"Most Rev. Emilio arlos Berlie Belaunzaran"},
		{id:140,name:"Most Rev. Enrique Delgado"},
		{id:141,name:"Most Rev. Etkielski"},
		{id:142,name:"Most Rev. Eugene Gerber"},
		{id:143,name:"Most Rev. Felipe Tejeda"},
		{id:144,name:"Most Rev. Florentino Zabalza, O.A.R."},
		{id:145,name:"Most Rev. Francis Furey"},
		{id:146,name:"Most Rev. Francisco Alvarez Martinez"},
		{id:147,name:"Most Rev. Francisco Javier Chavolla Ramos"},
		{id:148,name:"Most Rev. Francisco Robles"},
		{id:149,name:"Most Rev. Fransiscus Van Roessel, CICM"},
		{id:150,name:"Most Rev. Franz Daneels, O.Praem"},
		{id:151,name:"Most Rev. G. Patrick Ziemann"},
		{id:152,name:"Most Rev. G. Patrick Ziemann, D.D."},
		{id:153,name:"Most Rev. Gabino Zavala"},
		{id:154,name:"Most Rev. Gaetan Proulx, O.S.M."},
		{id:155,name:"Most Rev. George Rehring, D.D."},
		{id:156,name:"Most Rev. Gerhard Schwenzer, SS.CC."},
		{id:157,name:"Most Rev. Gilielmo Na (American)"},
		{id:158,name:"Most Rev. Godopredo Pedernal, D.D."},
		{id:159,name:"Most Rev. Gordon D. Bennett, D.D."},
		{id:160,name:"Most Rev. Gottwald"},
		{id:161,name:"Most Rev. Gratian Mundadan, CMI"},
		{id:162,name:"Most Rev. Hildebrandt Antoniutti"},
		{id:163,name:"Most Rev. Ireneo A. Amantillo, CSSR, DD"},
		{id:164,name:"Most Rev. Jaime Cardinal Sin, D.D."},
		{id:165,name:"Most Rev. Jaime Prieto"},
		{id:166,name:"Most Rev. Jaime Soto"},
		{id:167,name:"Most Rev. Jaime Soto, D.D."},
		{id:168,name:"Most Rev. James Francis McIntyre"},
		{id:169,name:"Most Rev. Jerome J. Hastrich"},
		{id:170,name:"Most Rev. Jesus B. Tuquib, DD"},
		{id:171,name:"Most Rev. John C. McNabb, OSA"},
		{id:172,name:"Most Rev. John D'Acy"},
		{id:173,name:"Most Rev. John Francis McIntyre, D.D."},
		{id:174,name:"Most Rev. John Magee"},
		{id:175,name:"Most Rev. John McGann"},
		{id:176,name:"Most Rev. John Paschang"},
		{id:177,name:"Most Rev. John Quinn"},
		{id:178,name:"Most Rev. John R. Quinn, D.D."},
		{id:179,name:"Most Rev. John Scanlan"},
		{id:180,name:"Most Rev. John Steinbeck"},
		{id:181,name:"Most Rev. John T. Steinbock, D.D."},
		{id:182,name:"Most Rev. Jose Maria Ciranda"},
		{id:183,name:"Most Rev. Jose Pablo Rovalo Azcue"},
		{id:184,name:"Most Rev. Joseph A. Fiorenza"},
		{id:185,name:"Most Rev. Joseph Cardinal Bernardin"},
		{id:186,name:"Most Rev. Joseph Federal"},
		{id:187,name:"Most Rev. Joseph G. Fernandez"},
		{id:188,name:"Most Rev. Joseph McGucken"},
		{id:189,name:"Most Rev. Joseph N. Perry"},
		{id:190,name:"Most Rev. Joseph Sartoris, D.D."},
		{id:191,name:"Most Rev. Joseph T. McGucken, D.D."},
		{id:192,name:"Most Rev. Joseph Thumma"},
		{id:193,name:"Most Rev. Juan Antonio Ugarte"},
		{id:194,name:"Most Rev. Juan Arzube"},
		{id:195,name:"Most Rev. Juan Arzube, D.D."},
		{id:196,name:"Most Rev. Julins B. Adelakum, D.D."},
		{id:197,name:"Most Rev. Julio X. Labayeng, BCP, D.D."},
		{id:198,name:"Most Rev. Julio Xabier Labayen, OCD, DD"},
		{id:199,name:"Most Rev. Julio Xavier Labayen, OCD, D.D."},
		{id:200,name:"Most Rev. Julio Xavier Lafoayen, OCD, D.D."},
		{id:201,name:"Most Rev. Julio Xavier Lagayen, OCD, DD"},
		{id:202,name:"Most Rev. Justin Driscoll"},
		{id:203,name:"Most Rev. Keoghi"},
		{id:204,name:"Most Rev. Kevin W. Vann"},
		{id:205,name:"Most Rev. Launcelot John Goody, D.D. R.B.E."},
		{id:206,name:"Most Rev. Leobardo Viera Contreras"},
		{id:207,name:"Most Rev. Luis Morales Reyes"},
		{id:208,name:"Most Rev. MacBride, OFM"},
		{id:209,name:"Most Rev. Mark Schmidt"},
		{id:210,name:"Most Rev. Matthew K. Gyamfi"},
		{id:211,name:"Most Rev. McCormack, Bishop of Meath"},
		{id:212,name:"Most Rev. MIchael Driscoll"},
		{id:213,name:"Most Rev. Michael Jarrel"},
		{id:214,name:"Most Rev. Michael P. Driscoll, D.D."},
		{id:215,name:"Most Rev. Miguel Cinches, SVD"},
		{id:216,name:"Most Rev. Miguel La Fay Barrdi"},
		{id:217,name:"Most Rev. NamSu Kim"},
		{id:218,name:"Most Rev. Nevin Hayes, O.Carm."},
		{id:219,name:"Most Rev. Nicholas M. Mondejar, D.D."},
		{id:220,name:"Most Rev. Nicholaus Chung"},
		{id:221,name:"Most Rev. Norman F.  McFarland, J.C.D."},
		{id:222,name:"Most Rev. Norman F. McFarland"},
		{id:223,name:"Most Rev. Norman F. McFarland, D.D."},
		{id:224,name:"Most Rev. Norman F. McFarland, D.D., J.C.D."},
		{id:225,name:"Most Rev. Norman McFarland"},
		{id:226,name:"Most Rev. Norman McFarland, D.D."},
		{id:227,name:"Most Rev. P. Pham Ngoic Chi"},
		{id:228,name:"Most Rev. Patelisio Punou-Ki Hihifo Finau Sm."},
		{id:229,name:"Most Rev. Patrick Joseph Skinner"},
		{id:230,name:"Most Rev. Patrick Kilomuble"},
		{id:231,name:"Most Rev. Paul Chittilappilly"},
		{id:232,name:"Most Rev. Paul E. Waldschmidt, CSC, STD"},
		{id:233,name:"Most Rev. Paul J. Hallinan"},
		{id:234,name:"Most Rev. Peter Anthony Rasazza"},
		{id:235,name:"Most Rev. Peter F. Christensen, D.D."},
		{id:236,name:"Most Rev. Peter kwaku Atuakene"},
		{id:237,name:"Most Rev. Peter Remigius"},
		{id:238,name:"Most Rev. Piquet, M.E.P."},
		{id:239,name:"Most Rev. Pocci"},
		{id:240,name:"Most Rev. Raimondi, Apostolic Delegate"},
		{id:241,name:"Most Rev. Raimondi-Apostolic Delegate"},
		{id:242,name:"Most Rev. Raymond Boland, D.D."},
		{id:243,name:"Most Rev. Raymond Kalisz, SVP"},
		{id:244,name:"Most Rev. Ricardo Bazzy"},
		{id:245,name:"Most Rev. Ricardo Garcia Garcia"},
		{id:246,name:"Most Rev. Robert McElroy, D.D."},
		{id:247,name:"Most Rev. Roberto Octavio Gonzalez Nieves, OFM"},
		{id:248,name:"Most Rev. Rolando J. Tria Tirona, OCD, D.D."},
		{id:249,name:"Most Rev. Rolando Tria Tirona, OCD, DD"},
		{id:250,name:"Most Rev. Romeo Blanchette"},
		{id:251,name:"Most Rev. Rudolph Akanlu"},
		{id:252,name:"Most Rev. S. Edward Francis, D.D."},
		{id:253,name:"Most Rev. Sang Sun O"},
		{id:254,name:"Most Rev. Scanlon"},
		{id:255,name:"Most Rev. Simon Hoa Nguyen Van Hien"},
		{id:256,name:"Most Rev. Sincero"},
		{id:257,name:"Most Rev. Stanley G. Schlarman, D.D."},
		{id:258,name:"Most Rev. Sylvester Ryan"},
		{id:259,name:"Most Rev. Terry J. Steib, S.V.D."},
		{id:260,name:"Most Rev. Thanh Thai Nguyen"},
		{id:261,name:"Most Rev. Theodore McCarrick"},
		{id:262,name:"Most Rev. Thien"},
		{id:263,name:"Most Rev. Thomas Curry"},
		{id:264,name:"Most Rev. Thomas Keogh"},
		{id:265,name:"Most Rev. Thomas Morris"},
		{id:266,name:"Most Rev. Thomas V. Dolinay"},
		{id:267,name:"Most Rev. Timothy E. Freyer"},
		{id:268,name:"Most Rev. Timothy Manning"},
		{id:269,name:"Most Rev. Tod D. Brown"},
		{id:270,name:"Most Rev. Tod D. Brown, D.D."},
		{id:271,name:"Most Rev. Tod D. Brown,D.D."},
		{id:272,name:"Most Rev. Tomas A. Clavel"},
		{id:273,name:"Most Rev. Tomas A. Clavel, D.D."},
		{id:274,name:"Most Rev. Traglia"},
		{id:275,name:"Most Rev. Tran Thanh Kham"},
		{id:276,name:"Most Rev. Vicente M. Nacarra, D.D."},
		{id:277,name:"Most Rev. Victor Balkw"},
		{id:278,name:"Most Rev. Vincent Hanley"},
		{id:279,name:"Most Rev. Vincent Sowah Boi-Nai, SVD"},
		{id:280,name:"Most Rev. Virgil Bercea"},
		{id:281,name:"Most Rev. Vlazny"},
		{id:282,name:"Most Rev. Walter F. Sullivan"},
		{id:283,name:"Most Rev. William Cosgrove"},
		{id:284,name:"Most Rev. William J. Levada"},
		{id:285,name:"Most Rev. William J. MCNaughton, M.M., D.D."},
		{id:286,name:"Most Rev. William Johnson"},
		{id:287,name:"Most Rev. William Johnson, D.D."},
		{id:288,name:"Most Rev. William McNaughton"},
		{id:289,name:"Most Rev. William O'Brien"},
		{id:290,name:"Most Rev. William R. Johnson"},
		{id:291,name:"Most Rev. William R. Johnson, D.D."},
		{id:292,name:"Most Rev. William R.Johnson"},
		{id:293,name:"Most Rev. Xiangtai Yang"},
		{id:294,name:"Most Rev.Tod D. Brown"},
		{id:295,name:"Most Reverend  Gulielmo Kil-mo Na"},
		{id:296,name:"Most Reverend Carlos Briseno, OAR"},
		{id:297,name:"Most Reverend John Howe"},
		{id:298,name:"Most. Rev. Faustin Ngabu"},
		{id:299,name:"Most. Rev. Steven J. Lopes"},
		{id:300,name:"Most. Rev. Sylvester Treinen, D.D."},
		{id:301,name:"Msgr. Girolameo Pregione, Apostolic Delegate"},
		{id:302,name:"Msgr. Ig. Suharyo"},
		{id:303,name:"Msgr. Ignatius Suharyo"},
		{id:304,name:"Msgr. Weyenburger"},
		{id:305,name:"Msgrs. Enrique Delgado Gomez"},
		{id:306,name:"Nicolas Cardinal Chung Jin Seok"},
		{id:307,name:"Octaviano Marquez Archbishop of Puebla de Los Angeles"},
		{id:308,name:"Paul C. Shulte"},
		{id:309,name:"Pope John Paul II"},
		{id:310,name:"Pope John Paul II, P.M."},
		{id:311,name:"Rev. Dr. Aloysius Paul D'souza"},
		{id:312,name:"Rev. Msgr. Antonius Theesjen, SVD"},
		{id:313,name:"Rev. Msgr. Elmer Miani"},
		{id:314,name:"Richard J. Cardinal Cushing"},
		{id:315,name:"Right Rev. Joseph Mukwaya"},
		{id:316,name:"RT. Rev. Joseph Thumma"},
		{id:317,name:"Sandor Kovacs"},
		{id:318,name:"Simon Hoa Nguyen Van Hien"},
		{id:319,name:"Sr. Obispo Auxiliar Don Luis Chavez Botello"},
		{id:320,name:"Terrance Cardinal Cooke"},
		{id:321,name:"Timothy Cardinal Dolan"},
		{id:322,name:"Very Rev. David Arias, OAR"},
		{id:323,name:"Very Rev. Debmot Ryan"},
        { id: 324, name: "Other" }
		

    ];
    public education: Common[] = [
        { id: 1, name: "Select" },
        { id: 2, name: "Elementary" },
        { id: 3, name: "High School" },
        { id: 4, name: "College" },
        { id: 5, name: "Seminary" },
        { id: 6, name: "Post Graduate" },
        { id: 7, name: "Degree" }
    ];
    public Degree: Common[] = [
        { id: 1, name: "Select" },
        { id: 2, name: "B.A." },
        { id: 3, name: "M.A." },
        { id: 4, name: "M.Div" },
        { id: 5, name: "A.A." },
        { id: 6, name: "B.S." },
        { id: 7, name: "Other" }
    ];
    public PassportCountry: Common[] = [
        { id: 1, name: "Other" },
        { id: 2, name: "USA" },
        { id: 3, name: "Vietnam" },
        { id: 4, name: "Mexico" }
    ];
    public Citizenship: Common[] = [
		{ id: 1, name: "Argentina" },
		{ id: 2, name: "Australia" },
		{ id: 3, name: "Canada" },
		{ id: 4, name: "China" },
		{ id: 5, name: "Colombia" },
		{ id: 6, name: "Czech Republic" },
		{ id: 7, name: "Ethiopia" },
		{ id: 8, name: "Philippines" },
		{ id: 9, name: "Germany" },
		{ id: 10, name: "Ghana" },
		{ id: 11, name: "Guatemala" },
		{ id: 12, name: "India" },
		{ id: 13, name: "Indonesia" },
		{ id: 14, name: "Ireland" },
		{ id: 15, name: "Italy" },
		{ id: 16, name: "Mexico" },
        { id: 17, name: "Nigeria" },
		{ id: 18, name: "Norway" },
		{ id: 19, name: "Peru" },
		{ id: 20, name: "Poland" },
		{ id: 21, name: "Romania" },
		{ id: 22, name: "El Salvador" },
        { id: 23, name: "Slovakia" },
		{ id: 24, name: "South Korea" },
		{ id: 25, name: "Spain" },
		{ id: 26, name: "Tonga" },
        { id: 27, name: "USA" },
		{ id: 28, name: "Uganda" },
		{ id: 29, name: "Vietnam" },
		{ id: 30, name: "Other" },
    ];
    public PriestAppraisal: Common[] = [
        { id: 1, name: "Select" },
        { id: 2, name: "Pastor" },
        { id: 3, name: "Rector" },
        { id: 4, name: "Parochial Vicar" },
        { id: 5, name: "Administrator" },
        { id: 6, name: "Vocation Director" }
    ];
	public DeaconAppraisal: Common[] = [
        { id: 1, name: "Select" },
        { id: 2, name: "Pastor" },
        { id: 3, name: "Rector" },
        { id: 4, name: "Parochial Vicar" },
        { id: 5, name: "Administrator" },
       // { id: 6, name: "Vocation Director" },
        { id: 7, name: "Personnel Board" },
        { id: 8, name: "Formation Board" },
        { id: 9, name: "Director of the Diaconate" },
        { id: 10, name: "Other" }
    ];
    public Reports: Comon[] = [
        { id: 1, name: "Status of Safe Environment Training", description: "Status of Safe Environment Training for an Organization" },
        { id: 2, name: "Persons Who Need Safe Environment Training", description: "Persons Who Need Safe Environment Training or Re-Training for an Organization" },
        { id: 3, name: "DOJ In Progress", description: "Persons Who Are Listed as DOJ In Progess for an Organization" },
        { id: 4, name: "FBI In Progress", description: "Persons Who Are Listed as FBI In Progess for an Organization" },
        { id: 5, name: "SE Training Report for all Organizations", description: "Background Check: Persons Who Need Safe Environment Training or Re-Training for an Organization" },
        { id: 6, name: "Annual Compliance Audit By Year", description: "Annual Compliance Audit for Fiscal Year 1999" },
        { id: 7, name: "Annual Compliance Audit for ALL Fiscal Years", description: "Annual Compliance Audit for All Fiscal Years" },
        { id: 8, name: "Summary Training Status", description: "Summary_Status_Training_Report" },
        { id: 9, name: "Summary Training Status for School", description: "Summary_Status_Training_Report (Schools)" },
        { id: 10, name: "Summary Training Status for Parish", description: "Summary_Status_Training_Report (Parish)" },
        { id: 11, name: "List of contacts for all Organizations", description: "Contact Report for Safe Environment" },
        { id: 12, name: "Persons Not Cleared To Work", description: "Persons Not Cleared To Work" },
        { id: 13, name: "Persons Who Have Ended Their Ministry", description: "Persons Who Have Ended Their Ministry" },
        { id: 14, name: "Pastor/Administrator Report", description: "Pastor/Administrator Report" },
        { id: 15, name: "Safe Environment Report", description: "Safe Environment Report" },

    ];
    public PristReports: Comon[] = [
		/*{ id: 0, name: "Priest Staffing Report", description: "Priest Staffing Report" },
       
        { id: 2, name: "Diocesan Priest Count by Status", description: "Diocesan Priest Count by Status" },
        
        { id: 4, name: "Extern Priest Count by Status", description: "Extern Priest Count by Status" },*/
		{ id: 3, name: "Diocesan Priest Report", description: "Diocesan Priest Report" },
        { id: 5, name: "Religious Priest Report", description: "Religious Priest Report" },
        { id: 6, name: "Priests Without Picture Report", description: "Priests Without Picture Report" },
		{ id: 1, name: "Active Priest Cell Phone Report", description: "Active Priest Cell Phone Report" },
        { id: 7, name: "Religious Priest in Diocese Report", description: "Religious Priest in Diocese Report" },
        { id: 8, name: "Extern Priest in Diocese Report", description: "Extern Priest in Diocese Report" },		
        { id: 9, name: "Priest Staffing Report (Landscape)", description: "Priest Staffing Report (Landscape)" },
        { id: 10, name: "Priest Staffing Report (Portrait)", description: "Priest Staffing Report (Portrait)" },
        { id: 11, name: "Parochial Vicar Report", description: "Parochial Vicar Report" },
        { id: 12, name: "Priest Aging Report", description: "Priest Aging Report" },
        { id: 13, name: "Priest Medicare Eligibility Report", description: "Priest Medicare Eligibility Report" },
        { id: 14, name: "Pastor Administrator Report", description: "Pastor Administrator Report" },
	];
	public deaconReports: Comon[] = [
        { id: 1, name: "Deacon Directory Report", description: "Deacon Directory Report" },
    ];

    public deaconStatus: Common[] = [
        { id: 1, name: "Active" },
        { id: 2, name: "Active-FR Out" },
        { id: 3, name: "Active-FR Outside" },
        { id: 4, name: "Active-In/Out" },
        { id: 5, name: "Active-Outside" },
        { id: 6, name: "Retired" },
        { id: 7, name: "Retired-Outside" },
        { id: 8, name: "Senior" },		
        { id: 9, name: "Active Deacon" },
        { id: 10, name: "Senior Serving Outside" },
        { id: 11, name: "Senior From Outside" },
        { id: 12, name: "Retired Deacon" },
        { id: 13, name: "Deacon Aspirant" },
        { id: 14, name: "Deacon Candidate" },
        { id: 15, name: "Deceased" },
        { id: 16, name: "Deacon Wife" },
        { id: 17, name: "Deacon Wife in Formation" }
    ];
	public typeOfVisa: Common[] = [
		{ id: 1, name: "F-1 Student Visa" },
		{ id: 1, name: "R-1 Religious Workers Visa" },
		{ id: 1, name: "B-2 Tourist Visa" },
		{ id: 2, name: "Other" }
	];
	public affiliation: Common[] = [
        { id: 1, name: "Select" },
        { id: 2, name: "Diocesan" },
        { id: 3, name: "Religious" },
        { id: 4, name: "Other" }, 
	];

    getUrl(url: string) {
        if (url.toUpperCase().includes("?")) {
            let b = [];
            b = url.split("?");
            return b[0];
        } else {
            return url;
        }
    }
}